export default __webpack_public_path__ + "static/demolition-started-f7fb81921d7f57f641e771f979e0a18d.png";